/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

interface UserPrefs {
  lang?: string;
  nbRow?: number;
}
interface ConnectedUser {
  _id: string;
  email: string;
  name: string;
  role: string;
  prefs?: UserPrefs;
}

export interface AuthenticationState {
  connectedUser: ConnectedUser;
  token: string;
  isLogged: boolean;
}

const initialState: AuthenticationState = {
  connectedUser: {} as ConnectedUser,
  token: '',
  isLogged: false,
};

const authenticationSlice = createSlice({
  name: 'authentication',
  initialState,
  reducers: {
    setConnectedUser(state, data) {
      state.connectedUser = data.payload.connectedUser;
    },
    setToken(state, data) {
      state.token = data.payload.token;
    },
    setIsLogged(state, data) {
      state.isLogged = data.payload.isLogged;
    },
    setLogOut(state) {
      localStorage.removeItem('user');
      state.connectedUser = {} as ConnectedUser;
      state.token = '';
      state.isLogged = false;
    }

  }
});

export const {
  setConnectedUser, setToken, setIsLogged, setLogOut
} = authenticationSlice.actions;
export default authenticationSlice.reducer;
